module.exports = function (BreakpointsService) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
           scope.breakpointsService = BreakpointsService;
        },
        template: require('./footer-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/footer/footer-directive.js
 **/